//
//
//
//
//
//
//

	export default {
		name: 'emptyView',
    data() {
			return {
				focus: false,
      }
    },
    props: {
	    title: {
	    	type: String,
		    default: ''
      },
      btnText: {
        type: String,
        default: ''
      },
      type: { // type: 1 空页面， 2：网络错误页
        type: Number,
        default: 1,
      },
    },
    computed: {
		  titleText () {
		    console.log(this.type)
		    if (this.type === 2) {
		      return '网络不给力'
        } else {
		      return this.title
        }
      }
    }
	}



// WEBPACK FOOTER //
// ./src/components/EmptyView/index.vue